import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "browse-menu" }
const _hoisted_2 = { class: "biotech-categories-dropdown" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Biotech Categories ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "browse-separator" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.biotechCategories, (item, i) => {
                return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                  key: i,
                  onClick: ($event: any) => (_ctx.selectBiotechCategory(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.biotech_type), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
              default: _withCtx(() => [
                _createVNode(_component_arrow_down)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_breadcrumb, { class: "browse-nav" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_breadcrumb_item, {
            to: {
        name: 'biotechList',
        query: {
          biotechType: this.store.state.selectedBiotechCategory
        }
      }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickBiotechCategoryCallback && _ctx.clickBiotechCategoryCallback(...args)))
              }, _toDisplayString(_ctx.selectedBiotechCategory), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          (_ctx.biotechVisible)
            ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
                key: 0,
                to: {
            path: 'datasetList',
            query: {
              biotechID: this.store.state.selectedBiotechID
            }
          }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickBiotechCallback && _ctx.clickBiotechCallback(...args)))
                  }, _toDisplayString(_ctx.selectedBiotech), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (_ctx.datasetVisible)
            ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.selectedDataset), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _hoisted_4,
    _createVNode(_component_el_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view, { class: "main-view" })
      ]),
      _: 1
    })
  ], 64))
}